<div class="customer-info-content">
  <h3 class="section-title">Customer Info</h3>

  <div class="customer-form-container">
    <form [formGroup]="customerForm" (ngSubmit)="onSave()">
      <div class="form-grid">
        <!-- First Row -->
        <div class="form-row">
          <div class="form-field">
            <label for="firstName" class="field-label">First Name</label>
            <input
              matInput
              id="firstName"
              formControlName="firstName"
              class="form-input"
              [class.error]="getFieldError('firstName')"
              placeholder="Enter first name"
            />
            <div class="error-message" *ngIf="getFieldError('firstName')">
              {{ getFieldError('firstName') }}
            </div>
            <!-- <div class="error-message" *ngIf="customerForm.get('firstName')?.errors?.['standardName']">
              {{ customerForm.get('firstName')?.errors?.['standardName']?.message }}
            </div> -->
          </div>

          <div class="form-field">
            <label for="lastName" class="field-label"
              >Last Name<span class="required">*</span></label
            >
            <input
              matInput
              id="lastName"
              formControlName="lastName"
              class="form-input"
              [class.error]="getFieldError('lastName')"
              placeholder="Enter last name"
            />
            <div class="error-message" *ngIf="getFieldError('lastName')">
              {{ getFieldError('lastName') }}
            </div>
            <!-- <div class="error-message" *ngIf="customerForm.get('lastName')?.errors?.['standardName']">
              {{ customerForm.get('lastName')?.errors?.['standardName']?.message }}
            </div> -->
          </div>
        </div>

        <!-- Second Row -->
        <div class="form-row">
          <div class="form-field">
            <label for="phone" class="field-label">Phone Number</label>
            <input
              matInput
              id="phone"
              formControlName="phone"
              class="form-input"
              [class.error]="getFieldError('phone')"
              placeholder="Enter phone number"
              (keyup)="onPhoneKeyup()"
            />
            <div class="error-message" *ngIf="getFieldError('phone')">Invalid phone number.</div>
          </div>

          <div class="form-field">
            <label for="email" class="field-label">Email</label>
            <input
              matInput
              id="email"
              formControlName="email"
              type="email"
              class="form-input"
              [class.error]="getFieldError('email')"
              placeholder="Ex: johndoe@example.com"
            />
            <div class="error-message" *ngIf="getFieldError('email')">
              {{ getFieldError('email') }}
            </div>
            <!-- <div class="error-message" *ngIf="customerForm.get('email')?.errors?.['strictEmail']">
              Please enter a valid email address.
            </div> -->
          </div>
        </div>
      </div>
    </form>

    <!-- Action Buttons - Show only when form has changed -->
    <div class="form-actions" *ngIf="hasFormChanged">
      <div class="action-buttons">
        <button type="button" class="cancel-button" (click)="onCancel()" [disabled]="isSaving">
          Cancel
        </button>
        <button type="button" class="save-button" (click)="onSave()" [disabled]="isSaving">
          <span *ngIf="isSaving">Saving...</span>
          <span *ngIf="!isSaving">Save</span>
        </button>
      </div>
    </div>
  </div>
</div>
